import React from 'react';
import PropTypes from 'prop-types';

import IconButtonComponent from './IconButton.styles';

import Icon from '../shared/Icon/Icon';

const IconButton = ({ icon, ...props }) => {
  return (
    <IconButtonComponent {...props}>
      <Icon icon={icon} />
    </IconButtonComponent>
  );
};

IconButton.propTypes = {
  icon: PropTypes.string,
};

export default IconButton;
